//  export const API_URL = 'http://localhost:8880';
// export const API_URL = 'http://192.168.137.19';
// export const API_URL = 'http://192.168.137.214:8880';
export const API_URL: any = (window as any).urls;
// export const API_URL = 'http://192.168.137.43:8880';
// export const API_URL = 'http://192.168.100.51:8888';
export const API_DOMAIN = 'localhost';
export const API_DOMAIN_SIGNATURE = 'http://localhost:7777';

// Constants for file types
export const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
export const EXCEL_EXTENSION = '.xlsx';

// export const API_URL = 'http://192.168.74.89';
// export const API_DOMAIN = '192.168.74.89';

// export const API_URL = 'https://api-dev.ghssvlis.com';
// export const API_DOMAIN = 'api-dev.ghssvlis.com';
